import { PaaRepository } from '@/store/paa-state/paa-state.repository';
import { DialogObject } from '../../../../components/dialog/dialog.types';

interface getPaaDeleteObjectProps {
  store?: PaaRepository;
  action: () => void;
  toggleVisiblity?: () => void;
}

export const getPaaDeleteObject = ({ store, action, toggleVisiblity }: getPaaDeleteObjectProps): DialogObject => {
  return {
    title: `Suppression de Plan annuel des achats`,
    description: 'Cet action est irréversible, veuillez reviser vos modifications avant de continuer',
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'Supprimer',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'Annuler',
        onClick: () => {
          toggleVisiblity?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
